import React, { JSX } from 'react';
import Box from '@mui/material/Box';
import './LoginRestricted.css';

interface LoginRestrictedProps {
  children?: React.ReactNode;
}

const LoginRestricted = (props: LoginRestrictedProps): JSX.Element => {
  const { children } = props;
  return (
    <Box className="LoginRestricted">
      <Box className="LoginRestricted-label">You must login to access this feature</Box>
      {children}
    </Box>
  );
};

export { LoginRestricted };
